import "../scss/style.scss";
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

/*------------------------------------------
	common
------------------------------------------*/
// SP menu
$(function() {
	$('.js-nav-btn').on('click',function() {
		$('.js-nav').fadeToggle();
		$(this).toggleClass('is-close');
		$('.js-header').toggleClass('is-navOpen');
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav').fadeOut();
		$('.js-nav-btn').removeClass('is-close');
		$('.js-header').removeClass('is-navOpen');
	});
});

// 下部固定CV（MV通過中〜通過後に表示 / 引っ込みはMV復帰時）
$(function() {
	var $cv = $('.js-cv02');
	if (!$cv.length) return;

	var mv = document.querySelector('.topMv') || document.querySelector('.lowerMv');
	if (!mv) {
		$cv.addClass('is-show');
		return;
	}

	var SHOW_RATIO = 0.95; // 画面高さの95%地点で表示
	var lastBottom = null;

	var update = function() {
		var bottom = mv.getBoundingClientRect().bottom;
		var showAt = window.innerHeight * SHOW_RATIO;

		// 初回（読み込み・リサイズ直後）は出る側の閾値で同期
		if (lastBottom === null) {
			$cv.toggleClass('is-show', bottom <= showAt);
			lastBottom = bottom;
			return;
		}

		if (bottom < lastBottom && bottom <= showAt) {
			// 下スクロール中：早めに表示
			$cv.addClass('is-show');
		} else if (bottom > lastBottom && bottom > 0) {
			// 上スクロール中：MVが戻ってきたら隠す（従来どおり）
			$cv.removeClass('is-show');
		}

		lastBottom = bottom;
	};

	update();
	$(window).on('scroll', update);
	$(window).on('resize', function() {
		lastBottom = null;
		update();
	});
});

// tab
$(function() {
	$('.js-tab-btn').click(function() {
		if ($(this).hasClass('is-active')) return;

		var index = $(this).parent().children('.js-tab-btn').index(this),
				$tabSet = $(this).parents('.js-tab-set'),
				$contents = $tabSet.find('.js-tab-content'),
				$current = $contents.filter('.is-show'),
				$next = $contents.eq(index);

		$(this).parent().children('.js-tab-btn').removeClass('is-active');
		$(this).addClass('is-active');

		if (!$current.length) {
			$next.stop(true, true).hide().addClass('is-show').slideDown(300);
			return;
		}

		$current.stop(true, true).fadeOut(300, function() {
			$(this).removeClass('is-show');
		});
		$next.stop(true, true).hide().addClass('is-show').fadeIn(300);
	});
});

// accordion
$(function() {
	$('.js-accordion-btn').append('<span class="btn"></span>')
	$('.js-accordion-btn').on('click', function() {
		$('+ .js-accordion-content', this).slideToggle();
		$(this).toggleClass('is-open');
	});
});

// scroll fade (.js-fade / .u-fade / .u-fade-right)
(function() {
	var targets = document.querySelectorAll('.js-fade');
	if (!targets.length) return;

	document.querySelectorAll('.js-fade-stagger').forEach(function(group) {
		var step = parseFloat(group.getAttribute('data-fade-stagger') || '0.1');
		if (isNaN(step)) step = 0.1;
		group.querySelectorAll('.js-fade').forEach(function(el, i) {
			el.style.setProperty('--fade-delay', (i * step) + 's');
		});
	});

	var show = function(el) {
		el.classList.add('is-inview');
	};

	if (!('IntersectionObserver' in window)) {
		targets.forEach(show);
		return;
	}

	var io = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (!entry.isIntersecting) return;
			show(entry.target);
			io.unobserve(entry.target);
		});
	}, {
		threshold: 0.2,
		rootMargin: '0px 0px -5% 0px'
	});

	targets.forEach(function(el) {
		io.observe(el);
	});
})();


/*------------------------------------------
	top
------------------------------------------*/
// js-top-works-slider
if(document.getElementsByClassName('js-top-works-slider').length) {
	document.addEventListener( 'DOMContentLoaded', function() {

		// 上段　(.js-top-works-slider)
		var jsTopWorksSlider_option	=	{
					type					:	'loop',
					gap						:	'20px',
					arrows				:	false,
					pagination		: false,
					autoWidth			: true,
					autoScroll: {
						speed					:	.5,
						pauseOnHover	:	false,
					},
				},
				jsTopWorksSlider = new Splide( '.js-top-works-slider', jsTopWorksSlider_option );
		jsTopWorksSlider.mount( { AutoScroll } );

		// 下段　(.js-top-works-slider-rev)
		var jsTopWorksSliderRev_option	=	{
					type					:	'loop',
					gap						:	'20px',
					arrows				:	false,
					pagination		: false,
					autoWidth			: true,
					autoScroll: {
						speed					:	-.5,
						pauseOnHover	:	false,
					},
				},
				jsTopWorksSliderRev = new Splide( '.js-top-works-slider-rev', jsTopWorksSliderRev_option );
		jsTopWorksSliderRev.mount( { AutoScroll } );

	});
}


/*------------------------------------------
	about
------------------------------------------*/
// js-about-partner-slider
if(document.getElementsByClassName('js-about-partner-slider').length) {
	document.addEventListener( 'DOMContentLoaded', function() {
		
		var jsAboutPartnerSlider_option	=	{
					type					:	'loop',
					speed					:	1000,
					arrows				:	false,
					autoplay			:	true,
				},
				jsAboutPartnerSlider = new Splide( '.js-about-partner-slider', jsAboutPartnerSlider_option );
		jsAboutPartnerSlider.mount();

	});
}


/*------------------------------------------
	works
------------------------------------------*/
// js-works-befoaf (Before / After 幅切り替え)
$(function() {
	$('.js-works-befoaf').click(function() {
		var index = $(this).parent().children('.js-works-befoaf').index(this);
		$(this).parent().children('.js-works-befoaf').removeClass('is-active').addClass('is-hide');
		$(this).addClass('is-active').removeClass('is-hide');
	});
});

// js-works-modal (ギャラリー拡大表示)
$(function() {
	var $modal = $('.js-works-modal');
	if (!$modal.length) return;

	var $img = $modal.find('.js-works-modal-img');
	var $prev = $modal.find('.js-works-modal-prev');
	var $next = $modal.find('.js-works-modal-next');
	var galleries = {};
	var currentGallery = '';
	var currentIndex = 0;

	$('.js-works-gallery-data').each(function() {
		var key = $(this).attr('data-gallery');
		try {
			galleries[key] = JSON.parse($(this).text() || '[]');
		} catch (e) {
			galleries[key] = [];
		}
	});

	var updateNav = function() {
		var list = galleries[currentGallery] || [];
		$prev.prop('disabled', currentIndex <= 0);
		$next.prop('disabled', currentIndex >= list.length - 1);
	};

	var show = function(index) {
		var list = galleries[currentGallery] || [];
		if (!list.length) return;
		currentIndex = Math.max(0, Math.min(index, list.length - 1));
		$img.attr('src', list[currentIndex]);
		updateNav();
	};

	var open = function(gallery, index) {
		currentGallery = gallery;
		$modal.prop('hidden', false);
		$('body').css('overflow', 'hidden');
		show(index);
	};

	var close = function() {
		$modal.prop('hidden', true);
		$('body').css('overflow', '');
		$img.attr('src', '');
	};

	$(document).on('click', '.js-works-modal-open', function() {
		open($(this).attr('data-gallery'), parseInt($(this).attr('data-index'), 10) || 0);
	});

	$modal.on('click', function(e) {
		if (e.target === this) close();
	});
	$modal.find('.js-works-modal-close').on('click', close);
	$prev.on('click', function() { show(currentIndex - 1); });
	$next.on('click', function() { show(currentIndex + 1); });

	$(document).on('keydown', function(e) {
		if ($modal.prop('hidden')) return;
		if (e.key === 'Escape') close();
		if (e.key === 'ArrowLeft') show(currentIndex - 1);
		if (e.key === 'ArrowRight') show(currentIndex + 1);
	});
});